import { unref } from 'vue';

export const toValue = (mayBeRefOrFunc) => {
    if (typeof mayBeRefOrFunc === 'function') {
        return mayBeRefOrFunc();
    } else {
        return unref(mayBeRefOrFunc);
    }
};
